import {Template, TemplateItemParams} from '@dv5/domain'
import React, {FC, useMemo, useState} from 'react'
import {Button} from '../inputs/Button'
import {extractPlaceholders, getPlaceholderDefaults} from '../service/templateService'
import './TemplateParamDialog.less'

interface Props {
    template: Template
    onConfirm: (params: TemplateItemParams) => void
    onCancel: () => void
}

export const TemplateParamDialog: FC<Props> = ({
                                                   template,
                                                   onConfirm,
                                                   onCancel,
                                               }) => {
    const placeholders = useMemo(() => extractPlaceholders(template.templateData), [template.templateData])

    const [values, setValues] = useState<TemplateItemParams>(() => {
        const initial: TemplateItemParams = {}
        const placeholderDefaults = getPlaceholderDefaults()
        for (const name of placeholders) {
            initial[name] = placeholderDefaults[name] ?? ''
        }
        return initial
    })

    const handleValueChange = (name: string, value: string) => {
        setValues(prev => ({...prev, [name]: value}))
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            onConfirm(values)
        }
    }

    return (
        <div className="template-param-dialog">
            <h4 className="param-dialog-title">Set template parameters</h4>
            <div className="param-dialog-template-name">{template.title}</div>

            {placeholders.length === 0 ? (
                <div className="param-dialog-empty">No parameters to set</div>
            ) : (
                <div className="param-dialog-fields">
                    {placeholders.map(name => (
                        <div key={name} className="param-field">
                            <label className="param-field-label" htmlFor={`param-${name}`}>{name}</label>
                            <input
                                id={`param-${name}`}
                                className="param-field-input"
                                type="text"
                                value={values[name] || ''}
                                placeholder={`Enter ${name}`}
                                onChange={e => handleValueChange(name, e.target.value)}
                                onKeyDown={handleKeyDown}
                                autoFocus={placeholders[0] === name}
                            />
                        </div>
                    ))}
                </div>
            )}

            <div className="param-dialog-buttons">
                <Button title="Cancel" onClick={onCancel} className="cancel-dialog-button"/>
                <Button title="Apply" onClick={() => onConfirm(values)}/>
            </div>
        </div>
    )
}
